import React, { useEffect, useRef, useState } from 'react'
import { TbBell, TbChevronDown, TbLogout, TbUser } from 'react-icons/tb'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { userActions } from '../../_actions'
import Breadcrumbs from './components/Breadcrumbs'

export default function Header(props) {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const [profileData, setProfileData] = useState([])


  const handleNotification = () => {
    navigate(`/app/notification`)
  }


  useEffect(() => {
    dispatch(userActions.getAdminProfile())
  }, [dispatch])

  useEffect(() => {
    setProfileData(selector?.users?.profileList)
  }, [selector])




  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])

  return (
    <>
      <div className='bg-[#ffffff] border-[#000]/10 border-b relative z-10 w-full px-4 sm:px-8 py-4 '>
        <div className='flex items-center justify-between'>
          <Breadcrumbs />

          <div
            className='relative flex items-center gap-2 text-sm transition-all duration-200 cursor-pointer'
            onClick={toggleDropdown}
          >
            <img
              src={profileData?.profile || '/img/profile-dumy.png'}
              alt='profile'
              className='rounded-full w-[45px] h-[45px] object-cover relative flex justify-center items-center border border-[#c7c7c7]'
            />
            <div className='hidden cursor-pointer lg:block'>
              <h1 className='text-lg text-[#212121] font-medium capitalize'>{profileData?.userName || 'Will smith'}</h1>
              <p className='text-[#212121B2] text-xs font-normal'>
                {profileData?.email || 'test@gmail.com'}
              </p>
            </div>
            <span className='hidden ml-4 lg:block'>
              <TbChevronDown size={20} className='text-black' />
            </span>

            {isDropdownOpen && (
              <div
                ref={dropdownRef}
                className='absolute right-0 top-16  w-48 rounded-md shadow-lg bg-[#fff] border border-[#000]/10 z-40'
              >
                <div
                  className='py'
                  role='menu'
                  aria-orientation='vertical'
                  aria-labelledby='options-menu'
                >
                  <div
                    className='px-4 py-2 text-sm text-[#212121] flex items-center gap-2 cursor-pointer hover:bg-[#00811D1A] hover:text-[#00811D]'
                    role='menuitem'
                    onClick={() => navigate(`/app/profile-security-management`)}
                  >
                    <span>
                      <TbUser size={20} />
                    </span>
                    Profile
                  </div>
                  <div
                    className='px-4 py-2 text-sm text-[#212121] flex items-center gap-2 cursor-pointer hover:bg-[#00811D1A] hover:text-[#00811D]'
                    role='menuitem'
                    onClick={handleNotification}
                  >
                    <span>
                      <TbBell size={20} />
                    </span>
                    Notification
                  </div>

                  <div
                    className='px-4 py-2 text-sm text-[#212121] flex items-center gap-2 cursor-pointer hover:bg-[#00811D1A] hover:text-[#00811D]'
                    role='menuitem'
                    onClick={props.openLogout}
                  >
                    <span>
                      <TbLogout size={20} />
                    </span>
                    Logout
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
